import { el } from '@/ui/dom';

/**
 * TransitionVeil.ts — a full-screen black "blink" that hides hard scene swaps
 * (M65): the globe-flight renderer cutting to the freshly built race world
 * used to be a single-frame jump. flash() snaps the veil opaque, then eases it
 * away over the new scene. Reduced motion skips it (a clean cut is calmer than
 * a fade for those users).
 */
export class TransitionVeil {
  private readonly veil: HTMLDivElement;
  private hideTimer: number | null = null;
  private readonly reducedMotion =
    typeof matchMedia !== 'undefined' && matchMedia('(prefers-reduced-motion: reduce)').matches;

  constructor(parent: HTMLElement) {
    this.veil = el('div', 'transition-veil', parent);
  }

  /** Cover the swap: opaque NOW, then fade out over `fadeMs`. */
  flash(fadeMs = 650): void {
    if (this.reducedMotion) return;
    if (this.hideTimer !== null) window.clearTimeout(this.hideTimer);
    this.veil.style.transition = 'none';
    this.veil.style.opacity = '1';
    void this.veil.offsetWidth; // commit the opaque frame before easing away
    this.veil.style.transition = `opacity ${fadeMs}ms ease`;
    this.veil.style.opacity = '0';
    this.hideTimer = window.setTimeout(() => {
      this.hideTimer = null;
    }, fadeMs);
  }

  dispose(): void {
    if (this.hideTimer !== null) window.clearTimeout(this.hideTimer);
    this.veil.remove();
  }
}
